var map = {
	"./affogato.jpg": 5832,
	"./aloe glass.jpg": 8048,
	"./amber peach.jpg": 61,
	"./americano2.jpg": 2954,
	"./aperol spritz.jpg": 7226,
	"./apple & rum punch.jpg": 7505,
	"./avocado toast.jpg": 2305,
	"./baileys mocha.jpg": 1056,
	"./blanc de blancs.jpg": 3463,
	"./botanical mist.jpg": 9523,
	"./brioche with banana & caramel.jpg": 6547,
	"./brunchpuri with chicken.jpg": 4012,
	"./brunchpuri with salmon.jpg": 7963,
	"./brunchpuri with shrimps.jpg": 5937,
	"./buckwheat risotto with bacon and poached egg.jpg": 3122,
	"./bumble4.jpg": 1882,
	"./cappuccino2.jpg": 5122,
	"./chicken schnitzel & salad mix.jpg": 5509,
	"./chocolate fondant1.jpg": 6922,
	"./cipriani pino grigio.jpg": 7727,
	"./citrus garden lemonade.jpg": 8843,
	"./cocoa apple strudel.jpg": 2567,
	"./cocoa2.jpg": 1206,
	"./coconut rice porridge with mango.jpg": 8081,
	"./cranberry tea.jpg": 119,
	"./eggs benedict on brioche with bacon.jpg": 7783,
	"./eggs benedict on brioche with salmon.jpg": 1078,
	"./english breakfast.jpg": 920,
	"./espresso tonic cherry.jpg": 6409,
	"./espresso tonic.jpg": 3848,
	"./espresso2.jpg": 7777,
	"./filter coffee  .jpg": 9073,
	"./flat white2.jpg": 4083,
	"./french fries with truffle mayo.jpg": 998,
	"./ginger & lemon tea.jpg": 2006,
	"./gnocchi with pesto cream & sun-dried tomatoes.jpg": 4890,
	"./ice matca mango coconut.jpg": 3767,
	"./ice matcha strawberry.jpg": 3893,
	"./kindzmarauli.jpg": 1232,
	"./latte-ice latte.jpg": 8441,
	"./mango chili lemonade.jpg": 2699,
	"./mango rose.jpg": 1312,
	"./masala .jpg": 8822,
	"./matcha latte-ice matcha latte.jpg": 1905,
	"./matcha orange3.jpg": 1570,
	"./matcha-ice matcha.jpg": 9321,
	"./mulled wine.jpg": 7235,
	"./mussels with cream.jpg": 3783,
	"./orange juice.jpg": 2157,
	"./pancake cheeseburger.jpg": 7264,
	"./pancakes with cherry compote and ice cream.jpg": 505,
	"./pancakes with condensed milk and banana.jpg": 7677,
	"./pancakes with salmon and cucumber.jpg": 5828,
	"./pear aloe lemonade.jpg": 8301,
	"./pear matcha latte.jpg": 5765,
	"./poke bowl with salmon.jpg": 5988,
	"./poke bowl with shrimp.jpg": 2259,
	"./pomegranate negroni.jpg": 4258,
	"./potato draniki with chicken.jpg": 37,
	"./potato draniki with salmon.jpg": 7512,
	"./protein coffee.jpg": 1072,
	"./protein matcha.jpg": 1676,
	"./pumpkin cream soup & crispy bacon.jpg": 1459,
	"./pumpkin waffle with poached egg.jpg": 9781,
	"./raf.jpg": 5160,
	"./raf2.jpg": 4272,
	"./raspberry & herbal tea.jpg": 6083,
	"./sea buckthorn tea.jpg": 2940,
	"./seasame raf.jpg": 9599,
	"./shakshuka.jpg": 6426,
	"./shrimp omelette.jpg": 9865,
	"./spinach couscous with avocado and poached egg.jpg": 1230,
	"./syrniki with cream cheese and cherries.jpg": 629,
	"./tea selection.jpg": 91,
	"./tempranillo.jpg": 5906,
	"./tipsy baby kisi.jpg": 9708,
	"./tom yum.jpg": 6656,
	"./truffle scrambled eggs with chanterelles.jpg": 8372,
	"./udon with chicken.jpg": 9546,
	"./udon with shrimp.jpg": 8086,
	"./udon with vegetables.jpg": 6539,
	"./v60.jpg": 8611,
	"./vino spumanto.jpg": 7096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2788;